module.exports = __webpack_public_path__ + "static/blue-river-f14fc80d74e42c8d297b2e61b5f9d727.jpg";